import { compact } from "lodash";

function CustomInfoAddress({ value }) {
  return compact([value?.address, value?.ward?.name, value?.city?.name]).join(", ");
}

export default CustomInfoAddress;
